import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from "@src/environments/environment";
import { oauthClientParams } from "@bt/configs";

export interface Credentials {
    email: string;
    password: string;
}

@Injectable()
export class TokenService {

    private requestHeader = { headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded') };

    constructor(private http: HttpClient) { }

    public createToken(credentials: Credentials) {
        const requestData = {
            ...oauthClientParams,
            grant_type: 'password',
            username: credentials.email,
            password: credentials.password
        };
        const requestBody = TokenService.encodeToFormdata(requestData);

        return this.http.post(environment.tokenUrl, requestBody, this.requestHeader);
    }

    public refreshToken(refreshToken: string) {
        const requestData = {
            ...oauthClientParams,
            grant_type: 'refresh_token',
            refresh_token: refreshToken
        };
        const requestBody = TokenService.encodeToFormdata(requestData);
        return this.http.post(environment.tokenUrl, requestBody, this.requestHeader);
    }

    private static encodeToFormdata(requestData) {
        return Object.keys(requestData).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(requestData[key]);
        }).join('&');
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/token.service.ts